import * as ZonesActions from '../actions/zones.actions';
import {DrawingModeEnum} from '../../../zones/models/drawing-mode.enum';

export interface State {
  error: any;
  drawChangeMode: DrawingModeEnum;
  highlightedZone: any;
  zonesVisibility: {[key: number]: boolean};
  lastMode: DrawingModeEnum;
}
export const initialState: State = {
  error: null,
  drawChangeMode: null,
  highlightedZone: null,
  zonesVisibility: {},
  lastMode: null
};

export function reducer(
  state = initialState,
  action: ZonesActions.ZonesActionsUnion
): State {
  switch (action.type) {
    case ZonesActions.drawCircle.type: {
      return {
        ...state,
        drawChangeMode: DrawingModeEnum.CIRCLE,
        lastMode: DrawingModeEnum.CIRCLE
      };
    }
    case ZonesActions.drawPolygon.type: {
      return {
        ...state,
        drawChangeMode: DrawingModeEnum.POLYGON,
        lastMode: DrawingModeEnum.POLYGON
      };
    }
    case ZonesActions.drawClear.type: {
      return {
        ...state,
        drawChangeMode: null
      };
    }
    case ZonesActions.highlightedZone.type: {
      return {
        ...state,
        highlightedZone: action.data
      };
    }
    case ZonesActions.zoneVisibility.type: {
      const zonesVisibility = Object.assign({}, state.zonesVisibility);
      if (action.data && action.data.length > 0) {
       action.data.forEach((zone: any) => zonesVisibility[zone.zoneId] = zone.visibility);
      }
      return {
        ...state,
        zonesVisibility: zonesVisibility,
      };
    }
    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getDrawChangeMode = (state: State) => state.drawChangeMode;
export const getHighlightedZone = (state: State) => state.highlightedZone;
export const getZoneVisibility = (state: State) => state.zonesVisibility;
export const getLastMode = (state: State) => state.lastMode;
